import GameRunner from './GameRunner';

export default GameRunner;
